<template>
    <v-card-title v-if="courseConfigsPending">
        <v-alert color="error" :value="true">
            Prezado(a) Coordenador(a), o cronograma público está desabilitado para o seu curso. <br>
            Acesse <router-link to="/curso/configuracoes" class="white--text"><strong><v-icon>settings</v-icon> Definições do curso</strong></router-link> e defina a data de publicação e início das inscrições.
        </v-alert>
    </v-card-title>
</template>

<script>
import auth from './../auth'

export default {
    name: 'UserWarnings',
    data() {
        return {
            courseConfigsPending: null
        }
    },
    methods: {
        coordinatedCoursesId() {
            let courses = []
            if (auth.user.authenticated 
                && (auth.user.roles.includes('examcoordinator') 
                    || auth.user.roles.includes('coursecoordinator'))) {            
                if (auth.user.courses_coordinator) {
                    courses = courses.concat(auth.user.courses_coordinator)
                }
                if (auth.user.courses_exam_coordinator) {
                    courses = courses.concat(auth.user.courses_exam_coordinator)
                }
            }
            return courses
        }
    },
    created() {
        let courses = this.coordinatedCoursesId()
        for (let course of courses) {
            this.$http.post('courseSettings', { course: course, key: 'enrollmentStartDate' }).then(response => {
                if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                    if (!response.data.config.value) {
                        this.courseConfigsPending = true
                    }                    
                }                    
            })             
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// UserWarnings.vue?a13ec78c